"use client";

import { FC } from "react";
import { FileText } from "lucide-react";
import { GetStudyNotebooksByNotebookIdDocumentsByDocumentIdChunksByChunkIdResponses } from "@/src/pages/study/client";

interface CitationPopoverProps {
  data: GetStudyNotebooksByNotebookIdDocumentsByDocumentIdChunksByChunkIdResponses[200];
  onOpenDocument?: (documentId: number) => void; // stub for now
}

export const CitationPopover: FC<CitationPopoverProps> = ({
  data,
  onOpenDocument,
}) => {
  return (
    <div className="space-y-2">
      {/* Header */}
      <div className="flex items-start justify-between gap-2 min-w-0 overflow-x-hidden">
        <div className="min-w-0">
          <div className="text-xs font-semibold text-theme-0 leading-tight line-clamp-2">
            {data.document_name}
          </div>
          <div className="text-[10px] text-gray-500">
            {typeof data.metadata?.page === "number"
              ? `Page ${data.metadata.page}`
              : ""}
          </div>
        </div>

        {/* View document button */}
        <button
          type="button"
          onClick={() => onOpenDocument?.(data.document_id)}
          className="flex items-center gap-1 rounded-md border border-gray-200 px-2 py-1 text-[10px] text-gray-600 transition hover:bg-gray-50 hover:text-gray-900"
        >
          <FileText className="h-3 w-3" />
          View
        </button>
      </div>

      {/* Divider */}
      <div className="h-px bg-gray-100" />

      {/* Content */}
      <div className="max-h-40 overflow-y-auto pr-1 text-xs leading-relaxed text-gray-700">
        {data.content}
      </div>

      {/* Footer */}
      {(data.created_at || data.updated_at) && (
        <div className="text-[10px] text-gray-400">
          {data.created_at && (
            <span>Added {new Date(data.created_at).toLocaleDateString()}</span>
          )}
        </div>
      )}
    </div>
  );
};
